import { getActiveQueryOwner, ownsQueryScope } from '../queries/queryOwnership';

const listeners = new Set();

export const subscribeNotificationRefresh = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

// Capture before a write so a late response cannot refresh a different login.
export const captureNotificationRefresh = () => {
  const owner = getActiveQueryOwner();
  return () => {
    if (!owner || !ownsQueryScope(owner)) return;
    listeners.forEach(listener => listener());
  };
};
